module.exports = __webpack_public_path__ + "img/poster.15c3f52c.png";